module.exports = __webpack_public_path__ + "img/indirect_icon.c3c6a8b8.svg";